import Route from '@ember/routing/route';

export default class VisitorsSetupGuideRoute extends Route {
  titleToken = 'Setup Guide';
}
